import React, { useState } from 'react';
import '../css/brochure.css';
import { Link } from 'react-router-dom';

const Brochure = ({ data }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [showMore, setShowMore] = useState(false);
  return (
    <section
      className="brochure m-0 py-5 lazy-bg skeleton loaded"
      id="brochure"
      style={{
        backgroundImage: 'url("./images/Section02-01-8.png")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="right-bg">
        <div className="container">
          <div className="wrap">
            <div className="row">
              <div className="brochure-left col-lg-6 col-12">
                <div className="brochure-video mt-lg-5 mb-3 lazy-bg skeleton loaded">
                  {!isPlaying ? (
                    <div
                      className="video-thumbnail"
                      style={{
                        backgroundImage: `url("${data?.imageUrl}")`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                      }}
                      onClick={() => setIsPlaying(true)}
                    >
                      <div
                        style={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          background: 'rgba(0, 0, 0, 0.6)',
                          borderRadius: '50%',
                          width: '50px',
                          height: '50px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <img
                          src="/images/icons/play.png"
                          alt="Play icon"
                          loading="lazy"
                          style={{
                            width: '50px',
                            height: '50px',
                          }}
                        />
                      </div>
                    </div>
                  ) : (
                    <iframe
                      className="video-thumbnail"
                      src={data.videoUrl}
                      title={data.title}
                      frameBorder="0"
                      allow="autoplay; encrypted-media"
                      allowFullScreen
                    />
                  )}
                </div>
              </div>
              <div className=" brochure-right col-lg-6 col-12">
                <div className="ps-lg-5 ms-lg-3 right">
                  <h1 className="default-box-title">
                    Hội cựu sinh viên Kinh tế K21 – Đại học Cần Thơ
                  </h1>
                  <p className="slogan">
                    <strong>
                      Kết nối giá trị – Lan tỏa tri thức – Đồng hành phát triển
                    </strong>
                  </p>
                  <div className="larry-page-quote position-relative">
                    <div className="quote">
                      “Hội cựu sinh viên Kinh tế K21 – Đại học Cần Thơ tự hào là cầu nối vững chắc giữa các thế hệ sinh viên,
                      nơi kết tinh của tình bạn, tri thức và hoài bão trưởng
                      thành. Chúng tôi không chỉ là một cộng đồng gắn bó vì kỷ
                      niệm, mà còn là tập thể giàu trách nhiệm, không ngừng lan
                      tỏa giá trị tốt đẹp đến xã hội và thế hệ sinh viên kế
                      thừa.”
                    </div>
                    <strong
                      className="position-absolute"
                      style={{ color: 'var(--color-detail-quote)' }}
                    >
                      Hội cựu sinh viên Kinh tế K21 - Đại học Cần Thơ
                    </strong>
                  </div>
                  <div className="mb-3 text">
                    Hội hoạt động trên nền tảng ba giá trị cốt lõi: Kết nối –
                    Đồng hành – Chia sẻ. Đó là sự kết nối bền vững giữa các
                    thành viên; là sự đồng hành trong sự nghiệp, cuộc sống và
                    phát triển cá nhân; là tinh thần sẻ chia trong từng hành
                    động, từng hoạt động cộng đồng và hỗ trợ sinh viên.
                    {showMore && (
                      <>
                        <br />
                        <br />
                        Từ những buổi gặp gỡ thân tình, đến các chương trình học
                        bổng, mentoring và kết nối doanh nghiệp – Hội cựu sinh viên Kinh tế K21 - Đại học Cần Thơ luôn nỗ lực tạo ra những giá trị thiết thực,
                        lan tỏa tinh thần nhân văn, và giữ vững hình ảnh của một
                        thế hệ sinh viên Cần Thơ bản lĩnh, trí tuệ, nghĩa tình.
                      </>
                    )}
                  </div>
                  <div>
                    <Link
                      to="#"
                      title=""
                      className="detail me-2"
                      onClick={(e) => {
                        e.preventDefault();
                        setShowMore(!showMore);
                      }}
                    >
                      {showMore ? 'Ẩn bớt' : 'Xem chi tiết'}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Brochure;
